module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp23_8017.5d9331ed.png";